/** Sesión del navegador: modal de invitado ya mostrado en esta pestaña/sesión */
export const GUEST_LIMITED_CONTENT_MODAL_KEY = "enarm_guest_limited_content_modal_seen";
